<!--
Important:
This Component is used only for the Vue3 application
Any modifications made should be done for Vue3 component also
Vue2File: wwwroot\js\ParagonGroup\components\ContactForm\ClassicContactForm.vue
Dont forget to make the changes in both the files
Any clarifications contact manideep
-->
<template>
  <div class="w-100">
    <form method="post" @submit.prevent="submitContact()" novalidate class="contactForm">
      <div class="contact-custom-lead-form-title">
        <h4 class="text-center color-white" v-html="contactTitle"></h4>
      </div>
      <div v-if="initialDisplay" class="mt-4 mx-4">
        <div class="contact-form">
          <div class="form-group">
              <input
                type="text"
                id="firstName"
                class="form-control"
                placeholder="First Name"
                :class="[{'error': errordetails.firstnameerror}]"
                v-model="contactdetails.FirstName"
                     @keypress="removeSpecialCharacter"
              />
          </div>
          <div class="form-group">
              <input
                type="text"
                id="lastName"
                class="form-control"
                placeholder="Last Name"
                :class="[{'error': errordetails.lastnameerror}]"
                v-model="contactdetails.LastName"
                     @keypress="removeSpecialCharacter"
              />
          </div>
          <div class="form-group">
              <input
                type="email"
                id="emailAddress"
                placeholder="Email"
                class="form-control"
                :class="[{'error': errordetails.emailerror}]"
                v-model="contactdetails.EmailAddress"
              />
          </div>
          <div class="form-group">
              <input
                type="text"
                id="phoneNumber"
                class="form-control"
                placeholder="Phone"
                :class="[{'error': errordetails.phoneerror}]"
                v-model="contactdetails.PhoneNumber"
                @keypress="isNumberKey"
              />
          </div>
          
        </div>
        <div slot="modal-footer">
          <div class="d-flex justify-content-end align-items-center">
            <div class="d-none">
              <label for="keepme">
                <input type="checkbox" id="keepme" />
                <span class="text-left">Keep me informed of {{make}} Specials</span>
              </label>
            </div>
            <div>
              <div class="d-flex justify-content-between align-items-center">
                <div>
                  <show-disclaimer></show-disclaimer>
                </div>
                <div class="text-right ml-3">
                  <input
                    type="submit"
                    value="Contact Us"
                    class="color-primary px-4 py-2 ft-16 rounded-buttons font-weight-bold"
                    style="background-color: #fff;" :disabled="disableSubmit"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
                        <div>
                        <form-submit-message 
                        :showMessageText="success" 
                        :leadTypeId="getLeadTypeId()"
                        :defaultMessage="''" >
                        </form-submit-message>
                        </div> 
      <div v-if="success" class="text-left">

        <div class="row">
          <div class="col">First Name :</div>
          <div class="col">{{contactdetails.FirstName}}</div>
        </div>
        <div class="row">
          <div class="col">Last Name :</div>
          <div class="col">{{contactdetails.LastName}}</div>
        </div>
        <div class="row">
          <div class="col">Email Address :</div>
          <div class="col">{{contactdetails.EmailAddress}}</div>
        </div>
        <div class="row">
          <div class="col">Phone Number :</div>
          <div class="col">{{contactdetails.PhoneNumber}}</div>
        </div>
        
      </div>
    </form>
  </div>
</template>

<script type="text/javascript" src="./ContactForm.js">
</script>
<style scoped>
input[type='text'],
input[type='email'],
textarea {
    background: transparent;
    width: 100%;
    border: none;
    border-bottom: 1px solid #fff;
    color: #fff;
    border-radius: 0px;
}

input[type='text']::placeholder,
input[type='email']::placeholder,
textarea::placeholder {
    color: #fff;
}

input[type='submit'] {
    border: none;
}

input:focus {
    background: transparent;
    color: #fff;
    outline: transparent;
    border-color: transparent;
    border-bottom: 1px solid #fff;
    box-shadow: none;
}

.error {
    border-color: red;
}

label {
    width: 100%;
}
</style>
